function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var FormManager = /*#__PURE__*/function () {
  // Constructor:
  function FormManager(form) {
    _classCallCheck(this, FormManager);

    this._form = form;
    this._isDirty = false;
    this._handleUnloadPageFunction = null;

    this._wireupValidation();

    this._form.setAttribute("novalidate", true);
  }

  _createClass(FormManager, [{
    key: "Dispose",
    value: function Dispose() {
      if (this._handleUnloadPageFunction != null) {
        window.removeEventListener("beforeunload", this._handleUnloadPageFunction);
      }
    } // Method for checking validity of entire form:

  }, {
    key: "IsValid",
    value: function IsValid() {
      var isValid = true;

      var _iterator = _createForOfIteratorHelper(this._form.elements),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;

          if (field.type != "submit" && field.type != "reset" && field.type != "hidden" && field.type != "button" && !field.disabled) {
            if (!this.ValidateField(field)) {
              isValid = false;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return isValid;
    }
  }, {
    key: "SetIsDirty",
    value: function SetIsDirty(value) {
      this._isDirty = value;
    } // Method for checking validity of particular form field

  }, {
    key: "ValidateField",
    value: function ValidateField(field) {
      var isValid = true;

      if (!!field.dataset.ignoreValidation) {
        return true;
      }

      var requiredMessage = field.dataset.requiredMessage || "Required";
      var invalidMessage = field.dataset.invalidMessage || "Invalid format";
      field.setAttribute('value', field.value); // Format validation:

      if (field.type == "date" && !!field.getAttribute("min") && new Date(field.getAttribute("min")) > new Date(field.value)) {
        this._setInvalid(field, invalidMessage);

        isValid = false;
      } else if (field.type == "date" && !!field.getAttribute("max") && new Date(field.value) > new Date(field.getAttribute("max"))) {
        this._setInvalid(field, invalidMessage);

        isValid = false;
      } else if (field.type != "date" && !!field.getAttribute("min") && field.getAttribute("min") > field.value.length) {
        this._setInvalid(field, invalidMessage);

        isValid = false;
      } else if (field.type != "date" && !!field.getAttribute("max") && field.value.length > field.getAttribute("max")) {
        this._setInvalid(field, invalidMessage);

        isValid = false;
      } else if (!!field.getAttribute("maxlength") && field.value.length > field.getAttribute("maxlength")) {
        this._setInvalid(field, invalidMessage);

        isValid = false;
      } else if (field.type === "tel" && field.value.length > 0 && field.value[0] !== '+' && !FormManager.PHONE_REGEX.test(field.value)) {
        this._setInvalid(field, invalidMessage);

        isValid = false;
      } else if (field.type === "email" && field.value.length > 0 && !FormManager.EMAIL_REGEX.test(field.value)) {
        this._setInvalid(field, invalidMessage);

        isValid = false;
      } else {
        this._setValid(field);
      } // Story: Make email required if phone is empty (and vice-versa)
      // Alternate field dependency (must have required attribute and require-if-blank="<alternate field name>")
      // i.e. This field is required if the provided field is not populated


      var dependencyPassed = true;

      if (!!field.dataset.requireIfBlank) {
        var $dependentField = this._form.querySelector("[name=\"".concat(field.dataset.requireIfBlank, "\"]"));

        if (!!$dependentField) {
          dependencyPassed = !this._checkRequired($dependentField);
        }
      } // Parent field dependency (must have required attribute and require-if="<parent field name>")
      // i.e. This field is required if the provided field is populated


      if (!!field.dataset.requireIf) {
        var $parentField = this._form.querySelector("[name=\"".concat(field.dataset.requireIf, "\"]"));

        if (!!$parentField) {
          dependencyPassed = this._checkRequired($parentField);
        }
      } // Required validation:


      if (field.getAttribute("required") != null && isValid == true && dependencyPassed == true) {
        isValid = this._checkRequired(field);

        if (!isValid) {
          this._setInvalid(field, requiredMessage);
        } else {
          this._setValid(field);
        }
      }

      return isValid;
    } // Method for resetting form after a successful submission

  }, {
    key: "Reset",
    value: function Reset() {
      var form = this._form;
      form.reset(); // TODO: remove when we figure out why reset() doesn't work for group-details contactForm

      this.ResetFormValues();
      this.SetIsDirty(false);
    }
  }, {
    key: "ResetValidationMessages",
    value: function ResetValidationMessages() {
      var form = this._form;

      for (var i = 0; i < form.length; i++) {
        var formElement = form.elements[i];

        switch (formElement.type) {
          case 'submit':
          case 'hidden':
          case 'reset':
          case 'button':
            // Do not reset value when type is one of above
            break;

          default:
            formElement.parentElement.classList.remove(FormManager.FIELD_CONTAINER_VALID_CLASSNAME);
            formElement.parentElement.classList.remove(FormManager.FIELD_CONTAINER_INVALID_CLASSNAME);

            this._clearMessages(formElement);

        }
      }
    } // Resets form element values to empty string

  }, {
    key: "ResetFormValues",
    value: function ResetFormValues() {
      var form = this._form;

      for (var i = 0; i < form.length; i++) {
        var formElement = form.elements[i];

        switch (formElement.type) {
          case 'submit':
          case 'hidden':
          case 'reset':
          case 'button':
            // Do not reset value when type is one of above
            break;

          default:
            formElement.setAttribute('value', '');
            formElement.parentElement.classList.remove(FormManager.FIELD_CONTAINER_VALID_CLASSNAME);
            formElement.parentElement.classList.remove(FormManager.FIELD_CONTAINER_INVALID_CLASSNAME);

            this._clearMessages(formElement);

            if (formElement.type === 'textarea') {//formElement.parentElement.lastElementChild.innerHTML = '';
            }

        }
      }
    } //Private methods:

  }, {
    key: "_checkRequired",
    value: function _checkRequired(field) {
      var isValid = true;

      switch (field.type) {
        case "checkbox":
          if (!!field.dataset.checkboxGroup) {
            // At least one checkbox in group satisfies requirement:
            isValid = this._form.querySelectorAll("input[data-checkbox-group='".concat(field.dataset.checkboxGroup, "']:checked")).length > 0;
          } else {
            isValid = field.checked;
          }

          break;

        case "radio":
          isValid = this._form.querySelectorAll("input[name='".concat(field.name, "']:checked")).length > 0;
          break;

        case "select-one":
        case "select-multiple":
          isValid = !!field.value;
          break;

        default:
          isValid = field.value.length > 0;
      }

      return isValid;
    }
  }, {
    key: "_wireupValidation",
    value: function _wireupValidation() {
      var _this = this;

      //Notify user when user is navigating away from dirty form:
      this._handleUnloadPageFunction = function (event) {
        if (!!_this._isDirty) {
          event.returnValue = true; // Browsers no longer display this custom message

          return "Are you sure you want to navigate away from this page? Changes made will not be saved.";
        }
      };

      window.addEventListener("beforeunload", this._handleUnloadPageFunction); //Immediately validate each field on change:

      var allElements = this._form.elements;
      Array.from(allElements).forEach(function (element) {
        element.addEventListener("change", function () {
          _this.ValidateField(element);

          _this.SetIsDirty(true); //Validate dependent fields:


          if (!!element.dataset.requireIfBlank) {
            var dependentField = _this._form.querySelector("[name=\"".concat(element.dataset.requireIfBlank, "\"]"));

            if (!!dependentField) {
              _this.ValidateField(dependentField);
            }
          }

          if (!!element.dataset.requireIf) {
            var parentField = _this._form.querySelector("[name=\"".concat(element.dataset.requireIf, "\"]"));

            if (!!parentField) {
              _this.ValidateField(parentField);
            }
          }
        });
      }); // Counter for text areas:

      var textAreas = this._form.querySelectorAll("textarea");

      Array.from(textAreas).forEach(function (element) {
        element.addEventListener("keyup", function () {
          var characterCount = element.value.length;
          var maxCount = element.getAttribute('maxlength') || 500;
          var counterDiv = element.nextElementSibling.nextElementSibling; // standardize placement of structure for nextElementSibling

          if (!!counterDiv && counterDiv.classList.contains(FormManager.TEXTAREA_COUNTER_CLASSNAME)) {
            if (characterCount > 0) {
              counterDiv.innerText = "".concat(characterCount, " / ").concat(maxCount);
            } else {
              counterDiv.innerText = '';
            }
          }
        });
      }); // Counter for input text boxes
      // Right now only used in mpp-custom-forms

      var textInputs = this._form.querySelectorAll('[data-input-text-counter]');

      Array.from(textInputs).forEach(function (element) {
        element.addEventListener("keyup", function () {
          var characterCount = element.value.length;
          var maxCount = element.getAttribute('maxlength') || 500;
          var counterDiv = element.nextElementSibling.nextElementSibling; // standardize placement of structure for nextElementSibling

          if (!!counterDiv && counterDiv.classList.contains(FormManager.TEXTAREA_COUNTER_CLASSNAME)) {
            if (characterCount > 0) {
              counterDiv.innerText = "".concat(characterCount, " / ").concat(maxCount);
            } else {
              counterDiv.innerText = '';
            }
          }
        });
      }); // Mask for phone numbers:

      var phoneFields = this._form.querySelectorAll("input[type='tel']");

      Array.from(phoneFields).forEach(function (element) {
        element.addEventListener("input", function (e) {
          if (!e.target.value.startsWith("+")) {
            var x = e.target.value.replace(/\D/g, '');

            if (x.length > 10) {
              x = x.match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);
              e.target.value = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '') + (x[4] ? '-' + x[4] : '');
            } else {
              x = x.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
              e.target.value = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
            }
          } else {
            var y = e.target.value.replace(/[^0-9\+\-]/g, '');
            e.target.value = y;
          }
        });
      });
    }
  }, {
    key: "_setInvalid",
    value: function _setInvalid(field, message) {
      var formField = field.closest(".".concat(FormManager.FIELD_CONTAINER_CLASSNAME));
      var formFieldAlt = field.closest(".".concat(FormManager.FIELD_CONTAINER_CLASSNAME_ALT));
      var existingMessageDiv = formField === null ? formFieldAlt.nextSibling : formField.nextSibling;

      if (!!existingMessageDiv && !!existingMessageDiv.classList && existingMessageDiv.classList.contains(FormManager.MESSAGE_CONTAINER_CLASSNAME)) {
        existingMessageDiv.parentNode.removeChild(existingMessageDiv);
      }

      if (!!formField) {
        formField.classList.remove(FormManager.FIELD_CONTAINER_VALID_CLASSNAME);
        formField.classList.add(FormManager.FIELD_CONTAINER_INVALID_CLASSNAME);
      } else {
        formFieldAlt.classList.remove(FormManager.FIELD_CONTAINER_VALID_CLASSNAME);
        formFieldAlt.classList.add(FormManager.FIELD_CONTAINER_INVALID_CLASSNAME);
      }

      if (message !== "") {
        var messageDiv = document.createElement("div");
        messageDiv.setAttribute("class", FormManager.MESSAGE_CONTAINER_CLASSNAME);
        messageDiv.innerHTML = "<label class=\"mppw-form-field__message--is-invalid\">".concat(message, "</label>");

        if (!!formField) {
          formField.parentNode.insertBefore(messageDiv, formField.nextSibling);
        } else {
          formFieldAlt.parentNode.insertBefore(messageDiv, formFieldAlt.nextSibling);
        }
      }
    }
  }, {
    key: "_setValid",
    value: function _setValid(field) {
      var formField = field.closest(".".concat(FormManager.FIELD_CONTAINER_CLASSNAME));
      var formFieldAlt = field.closest(".".concat(FormManager.FIELD_CONTAINER_CLASSNAME_ALT));
      var existingMessageDiv = formField === null ? formFieldAlt.nextSibling : formField.nextSibling;

      if (!!existingMessageDiv && !!existingMessageDiv.classList && existingMessageDiv.classList.contains(FormManager.MESSAGE_CONTAINER_CLASSNAME)) {
        existingMessageDiv.parentNode.removeChild(existingMessageDiv);
      }

      if (!!formField) {
        formField.classList.remove(FormManager.FIELD_CONTAINER_INVALID_CLASSNAME);
        formField.classList.add(FormManager.FIELD_CONTAINER_VALID_CLASSNAME);
      } else {
        formFieldAlt.classList.remove(FormManager.FIELD_CONTAINER_INVALID_CLASSNAME);
        formFieldAlt.classList.add(FormManager.FIELD_CONTAINER_VALID_CLASSNAME);
      }
    }
  }, {
    key: "_clearMessages",
    value: function _clearMessages(field) {
      var formField = field.closest(".".concat(FormManager.FIELD_CONTAINER_CLASSNAME));
      var formFieldAlt = field.closest(".".concat(FormManager.FIELD_CONTAINER_CLASSNAME_ALT));
      var existingMessageDiv = formField === null ? formFieldAlt.nextSibling : formField.nextSibling;

      if (!!existingMessageDiv && !!existingMessageDiv.classList && existingMessageDiv.classList.contains(FormManager.MESSAGE_CONTAINER_CLASSNAME)) {
        existingMessageDiv.parentNode.removeChild(existingMessageDiv);
      }

      if (!!formField) {
        formField.classList.remove(FormManager.FIELD_CONTAINER_INVALID_CLASSNAME);
        formField.classList.remove(FormManager.FIELD_CONTAINER_VALID_CLASSNAME);
      } else {
        formFieldAlt.classList.remove(FormManager.FIELD_CONTAINER_INVALID_CLASSNAME);
        formFieldAlt.classList.remove(FormManager.FIELD_CONTAINER_VALID_CLASSNAME);
      }
    }
  }], [{
    key: "TEXTAREA_COUNTER_CLASSNAME",
    get: //Constants:
    function get() {
      return "mppw-textarea-counter";
    }
  }, {
    key: "MESSAGE_CONTAINER_CLASSNAME",
    get: function get() {
      return "mppw-form-field__message_container";
    }
  }, {
    key: "FIELD_CONTAINER_CLASSNAME",
    get: function get() {
      return "mppw-form-field";
    }
  }, {
    key: "FIELD_CONTAINER_CLASSNAME_ALT",
    get: function get() {
      return "mppw-form-field-alt";
    }
  }, {
    key: "FIELD_CONTAINER_VALID_CLASSNAME",
    get: function get() {
      return "mppw-form-field--is-valid";
    }
  }, {
    key: "FIELD_CONTAINER_INVALID_CLASSNAME",
    get: function get() {
      return "mppw-form-field--is-invalid";
    }
  }, {
    key: "EMAIL_REGEX",
    get: function get() {
      return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    }
  }, {
    key: "PHONE_REGEX",
    get: function get() {
      return /^((\d{3}-\d{3}-\d{4}( x\d+)?)|(\d{11}( x\d+)?)|(\+\d.*))$/;
    }
  }]);

  return FormManager;
}();